import React, { useMemo, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Steps } from "antd";

import { RutasDidacticasFormStep1 } from "./RutasDidacticasFormStep1";
import { RutasDidacticasFormStep2 } from "./RutasDidacticasFormStep2";
import { RutasDidacticasFormStep3Share } from "./RutasDidacticasFormStep3Share";
import { BrandThemeProvider } from "../../../../ui";

import "./RutasStep.scss";

export function RutasDidacticasFormSteps({
  accessToken,
  teacher,
  onClose,
  onReload,
  forceCreateMode,
}) {
  const { t } = useTranslation("itineraries");
  const [currentStep, setCurrentStep] = useState(0);
  const [createdRoute, setCreatedRoute] = useState(null);

  const stepItems = useMemo(
    () => [
      { title: t("form.step1") },
      { title: t("form.step2") },
      { title: t("form.step3") },
    ],
    [t],
  );

  const handleClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  return (
    <BrandThemeProvider>
      <Modal
        open
        onCancel={handleClose}
        footer={null}
        width={760}
        destroyOnHidden
        maskClosable={false}
        className="rutas-wizard-modal"
      >
        <div className="rutas-wizard">
          <Steps
            current={currentStep}
            items={stepItems}
            className="rutas-wizard__steps"
          />

          {currentStep === 0 && (
            <RutasDidacticasFormStep1
              accessToken={accessToken}
              teacher={teacher}
              forceCreateMode={forceCreateMode}
              onClose={handleClose}
              onReload={onReload}
              onRouteCreated={(route) => {
                setCreatedRoute(route);
                setCurrentStep(1);
              }}
            />
          )}

          {currentStep === 1 && (
            <RutasDidacticasFormStep2
              accessToken={accessToken}
              teacher={teacher}
              route={createdRoute}
              onReload={onReload}
              onClose={handleClose}
              onNext={() => setCurrentStep(2)}
            />
          )}

          {currentStep === 2 && (
            <RutasDidacticasFormStep3Share
              accessToken={accessToken}
              teacher={teacher}
              route={createdRoute}
              onReload={onReload}
              onClose={handleClose}
              onPrev={() => setCurrentStep(1)}
            />
          )}
        </div>
      </Modal>
    </BrandThemeProvider>
  );
}
